import AvailableOffers from './AvailableOffers';
export default AvailableOffers;
